module.exports = __webpack_public_path__ + "img/equityIcon3.3a37e465.png";